<script lang="ts">
  import type { Person } from "../../helpers/types";
  import Card from "../atoms/Card.svelte";
  import Heading from "../atoms/Heading.svelte";
  import Link from "../atoms/Link.svelte";
  import Text from "../atoms/Text.svelte";
  import format from "date-fns/format";

  interface Props {
    isLoading: boolean;
    onChange: () => void;
    pin: number;
    email: string;
    phone: string;
    person: Person;
    invoiceDescription: string;
    invoiceValue: string | undefined;
    authority: boolean;
    facilityId: string | undefined;
    areaId: string | undefined;
    startDate: Date;
    facilityAddress: string;
    facilityZipcode: string;
    facilityCity: string;
    apartmentNumber?: string | undefined;
    formerResidence?: string | undefined;
    propertyOwner?: string | undefined;
  }

  let {
    isLoading,
    onChange,
    pin,
    email,
    phone,
    person,
    invoiceDescription,
    invoiceValue,
    authority,
    facilityId,
    areaId,
    startDate,
    facilityAddress,
    facilityZipcode,
    facilityCity,
    apartmentNumber = undefined,
    formerResidence = undefined,
    propertyOwner = undefined,
  }: Props = $props();
</script>

<Card>
  <div class="flex justify-between items-start break-words">
    <Heading variant="primary">Dina uppgifter</Heading>
    {#if !isLoading}
      <Link class={"flex-shrink-0"} onClick={() => onChange()}>Ändra</Link>
    {/if}
  </div>
  <Text variant="primary" class="text-M">Personnummer: {pin}</Text>
  <Text variant="primary" class="text-M"
    >Fakturaadress: {person.address}, {person.zipcode} {person.city}</Text
  >
  <Text variant="primary" class="text-M"
    >Kontaktuppgifter: {person.firstname} {person.lastname}</Text
  >
  <Text variant="primary" class="text-M">E-post: {email}</Text>
  <Text variant="primary" class="text-M">Mobiltelefon: {phone}</Text>
  <!-- invoice -->
  <div class="flex justify-between mt-4">
    <Text variant="primary" class="text-M">
      Skicka faktura via {invoiceDescription + (invoiceValue ? ":" : "")}
      {#if invoiceValue}
        {invoiceValue}
      {/if}
    </Text>
  </div>
  <!-- facility -->
  <p class="text-Neutral900 text-base font-bold mt-4">Anläggningsuppgifter</p>
  {#if authority}
    <Text variant="primary" class="text-M">Låt Skellefteå Kraft sköta bytet</Text>
    <Text variant="primary" class="text-M"
      >Anläggningsadress: {facilityAddress}, {facilityZipcode} {facilityCity}</Text
    >
  {:else}
    <Text variant="primary" class="text-M"
      >Anläggningsadress: {facilityAddress}, {facilityZipcode} {facilityCity}</Text
    >
    <Text variant="primary" class="text-M">Anläggnings-ID: {facilityId}</Text>
    <Text variant="primary" class="text-M">Områdes-ID: {areaId}</Text>
  {/if}
  {#if formerResidence}
    <Text variant="primary" class="text-M">Namn på tidigare boende: {formerResidence}</Text>
  {/if}
  {#if apartmentNumber}
    <Text variant="primary" class="text-M">Lägenhetsnummer: {apartmentNumber}</Text>
  {/if}
  {#if propertyOwner}
    <Text variant="primary" class="text-M">Fastighetsägare/hyresvärd: {propertyOwner}</Text>
  {/if}
  <!-- Startdate -->
  {#if !authority}
    <p class="text-Neutral900 text-base font-bold mt-4">Startdatum för elavtal</p>
    <Text variant="primary" class="text-M">{format(startDate, "YYYY-MM-DD")}</Text>
  {/if}
</Card>
